module.exports = __webpack_public_path__ + "static/media/filter-icon-popular.8f940bf7.svg";